import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Tailwind-aware className merge: clsx resolves conditionals/arrays, twMerge dedupes
// conflicting utilities (later wins) so callers can override primitive defaults safely.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
